module.exports = __webpack_public_path__ + "static/img/日立模块.57d3df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/日立模块.png
// module id = W9O3
// module chunks = 1